import { ECurrency, ELanguage } from '@ringana/configs';
import { IMerchandiseItem } from '@/common/interfaces/merchandise.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import { IApiRequestObject } from '@/common/interfaces/api.interface';
import { EErrorMessage } from '@/common/enums/messages.enum';
import FetchHelper from '../helpers/OldFetchHelper';
import OldErrorHandlerHelper from '../helpers/OldErrorHandlerHelper';
import CookieHelper from '../helpers/OldCookieHelper';
import ApiService from './ApiService';
import ApplicationError from '../errors/application-error';

export default class ProductService {
  private apiService: ApiService;
  partnerProductBusinessCardMatchCodes: string[] = [];
  partnerProductCarDecalMatchCodes: string[] = [];

  matchcodesInitialized = false;

  public constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  private async init(): Promise<void> {
    await this.fetchMerchandiseMatchcodes();
  }

  public async fetchMerchandiseMatchcodes(): Promise<void> {
    const fetchResult = await FetchHelper.get({ path: `/products/merchandise/matchcodes` });
    if(fetchResult.success) {
      this.partnerProductBusinessCardMatchCodes = fetchResult.data.businessCards;
      this.partnerProductCarDecalMatchCodes = fetchResult.data.carDecals;
      this.matchcodesInitialized = true;
    } else {
      OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
    }
  }

  public async isBusinessCard(productInfo: IProduct | IMerchandiseItem): Promise<boolean> {
    if(!productInfo) {
      return false;
    }
    if(!this.matchcodesInitialized) {
      // prevent race conditions
      await this.init();
    }
    return this.partnerProductBusinessCardMatchCodes.includes(productInfo.matchcode);
  }

  public async isCarDecal(productInfo: IProduct | IMerchandiseItem): Promise<boolean> {
    if(!productInfo) {
      return false;
    }
    if(!this.matchcodesInitialized) {
      // prevent race conditions
      await this.init();
    }
    return this.partnerProductCarDecalMatchCodes.includes(productInfo.matchcode);
  }

  public async getHomepageOfferProducts(currency?: ECurrency, language?: ELanguage): Promise<IProduct[]> {
    const requestOptions = {
      data: {
        currency: currency || CookieHelper.getCurrency(),
        language: language || CookieHelper.getLanguage(),
      },
    };
    const allReducedProducts = await this.apiService.getReducedProducts(requestOptions);
    return allReducedProducts.filter(product => !product.partnerApplicationProduct && product.purchasePossible);
  }

  public getProductInfos(matchcode: string): Promise<IProduct> {
    const options: IApiRequestObject = {
      params: {
        matchcode,
      },
    };
    try {
      return this.apiService.getProductInfos(options);
    } catch (err) {
      throw new ApplicationError(window.errorTexts[EErrorMessage.INFOWORX_RESPONSE_GET_PRODUCTS] as EErrorMessage);
    }
  }
}
